import { useCallback, useMemo } from 'react';
import { get } from 'lodash';
import { useBillingTools } from './useBillingTools';
import { useCampaignsTools } from './useCampaignsTools';
import { useChatTools } from './useChatTools';
import { useReportingTools } from './useReportingTools';

export const useTools = ({ closeChat, openChat, sendResponseToChatAgent }) => {
    const billing = useBillingTools({ closeChat, openChat, sendResponseToChatAgent });
    const campaigns = useCampaignsTools({ closeChat, openChat, sendResponseToChatAgent });
    const chat = useChatTools({ openChat, closeChat, sendResponseToChatAgent });
    const reporting = useReportingTools({ closeChat, openChat, sendResponseToChatAgent });

    const namespaces = useMemo(() => {
        return {
            billing,
            campaigns,
            chat,
            reporting,
        };
    }, [billing, campaigns, chat, reporting]);

    const getTool = useCallback(
        (toolName, message) => {
            const tool = get(namespaces, toolName);
            if (!tool) {
                throw new Error(`Tool ${toolName} not found`);
            }

            return args => {
                const { value } = message?.componentData || {};
                const { args: argsFromAction } = message?.actionData || {};

                let methodArgs = argsFromAction || args;
                if (!argsFromAction && !args && value) {
                    try {
                        methodArgs = JSON.parse(value || args);
                    } catch (error) {}
                }

                return tool(methodArgs, message);
            };
        },
        [namespaces]
    );
    return { getTool, namespaces };
};
